import { get } from 'lodash';
import parseFieldKey from './helpers/parseFieldKey';
import { FieldInputData } from './helpers/typings';

type GetAgentFieldInputValuesOutput = {
  hasAllValues: boolean;
  fieldInputData: FieldInputData;
};

const getAgentFieldInputValues = ({
  formValues,
  rowsToRun,
  fieldsByKey,
  inputFieldKeys,
}: {
  formValues: Record<string, string>;
  rowsToRun: number[];
  fieldsByKey: Record<string, { label: string }>;
  inputFieldKeys: string[];
}): GetAgentFieldInputValuesOutput => {
  const fieldInputData: Record<string, { value: string | null; label: string | null }> = {};

  let hasAllValues = true;
  inputFieldKeys.forEach((fik) => {
    const value = get(formValues, fik, null);

    // Look at the fieldKey in the list and get the index
    const parsedKey = parseFieldKey(fik);
    const fieldKeyIndex = parsedKey.rowIndex;
    const originalFieldKey = parsedKey.fieldKey || parsedKey.fullFieldKey;

    // If the fieldInputKey is not in the changed list row, don't send to server
    if (fieldKeyIndex !== null && !rowsToRun.includes(fieldKeyIndex)) {
      return;
    }

    fieldInputData[fik] = {
      label: fieldsByKey[originalFieldKey]?.label,
      value,
    };
    if ((value === undefined || value === null) && parsedKey.fieldKey !== '_associatedWithId') { // allows boxindex to check for duplicates without being prevented from running when a field is marked as no longer duplicate
      hasAllValues = false;
    }
  });

  return {
    fieldInputData,
    hasAllValues,
  };
};

export default getAgentFieldInputValues;